import type { ActivitiesStreamEvent } from '@d-orca/shared/client/apis';
import { SseChannel, siteStreamUrl, type ISseChannelHandlers } from './sseChannel';

// Browser-side client for `/api/sites/:siteId/activities/stream`.
//
// Every frame is an INVALIDATION, not a payload — "something about this site's
// activities changed, refetch". That is the whole contract: the page never has
// to merge a Trusstor frame into a joined row, and a shape change upstream
// cannot corrupt what it shows. The frame type is shared with the mobile app.

export type { ActivitiesStreamEvent };

export type ActivitiesStreamHandlers = ISseChannelHandlers<ActivitiesStreamEvent>;

export class ActivitiesStream {
  private readonly channel: SseChannel<ActivitiesStreamEvent>;

  constructor(siteId: string, handlers: ActivitiesStreamHandlers) {
    this.channel = new SseChannel(siteStreamUrl(siteId, 'activities/stream'), handlers);
  }

  open(): void {
    this.channel.open();
  }

  close(): void {
    this.channel.close();
  }
}
